import axios from "axios";

import {
  clearLocalStorage,
  getLocalStorage,
  setLocalStorage,
} from "../utils/auth";

// export const baseURL = "https://bseb.eplanetsoft.com/";
export const baseURL = "https://backend.bsebblockchain.in/";

//export const baseURL = "http://13.127.79.175:4015/";

const api = axios.create({
  baseURL: baseURL,
});

api.interceptors.request.use(
  (config) => {
    const token = getLocalStorage("access");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (token) {
      prom.resolve(token);
    } else {
      prom.reject(error);
    }
  });
  failedQueue = [];
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If 401, try to refresh the token
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return api(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken = getLocalStorage("refresh");
        if (!refreshToken) {
          clearLocalStorage();
          window.location.href = "/login"; // Redirect to login if no refresh token
          return Promise.reject(error);
        }

        const { data } = await axios.post(
          // "http://13.201.199.252:8000/api/token/refresh/",
          `${baseURL}token/refresh/`,
          { refresh: refreshToken }
        );
        setLocalStorage("access", data.access);
        processQueue(null, data.access);
        originalRequest.headers.Authorization = `Bearer ${data.access}`;
        return api(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        clearLocalStorage();
        window.location.href = "/login"; // Redirect to login if refresh fails
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
